import React from "react";
import { Link } from "react-router-dom";
import { makeStyles, Grid, Typography } from "@material-ui/core";
import Progress from "./progress";

const useStyles = makeStyles((theme) => ({
  safeColor: {
    color: "#1a90ff",
  },
  warnColor: {
    color: "#ffa31a",
  },
  limitColor: {
    color: "#ff1a1a",
  },
}));

export default function usage({ totalCount, currentLimit, releaseLimit }) {
  const classes = useStyles();
  const ratio = Math.floor((totalCount / currentLimit) * 100) || 0;
  return (
    <>
      <Grid container alignItems="center" spacing={3}>
        <Grid item>
          <Grid container alignItems="center">
            <Typography variant="h6" component="h6">
              ご契約件数状況：
            </Typography>
            <Typography>
            {ratio < 80 && (
              <span className={classes.safeColor}>{totalCount}</span>
            )}
            {(ratio >= 80 && ratio < 90) && (
              <span className={classes.warnColor}>{totalCount}</span>
            )}
            {ratio >= 90 && (
              <span className={classes.limitColor}>{totalCount}</span>
            )}
              /
            </Typography>
            <Typography>{currentLimit}件</Typography>
          </Grid>
        </Grid>
        <Grid item>
          <Grid container alignItems="center">
            <Typography variant="h6" component="h6">
              使用率：
            </Typography>
            <Typography>
              {ratio < 80 && (
                <span className={classes.safeColor}>{ratio}%</span>
              )}
              {(ratio >= 80 && ratio < 90) && (
                <span className={classes.warnColor}>{ratio}%</span>
              )}
              {ratio >= 90 && (
                <span className={classes.limitColor}>{ratio}%</span>
              )}
            </Typography>
          </Grid>
        </Grid>
        <Grid item>
          <Grid container alignItems="center">
            <Typography variant="h6" component="h6">
              増量オプション：
            </Typography>
            <Typography>{releaseLimit}回</Typography>
          </Grid>
        </Grid>
        {releaseLimit > 0 && (
          <Grid item>
            <Link 
              to="/limit_release"
              style={{ textDecoration: 'none' }}
            >
              <Typography>
                [ご利用はこちら]
              </Typography>
            </Link>
          </Grid>
        )}
      </Grid>

      <Progress ratio={ratio} />
    </>
  );
}
